// A cast from a slot asks first. A press on a slot opens the card of its spell
// over the board, with Back and Cast. Cast makes the cast. A spell with picks
// then waits for them, and Back in the cue takes it back. Escape does Back in
// both places. Added 2026-10-14. Garrett: "there should also be a button to
// back out or some way to back out of this view so I don't have to play the
// spell by default since on mobile, I wouldn't have known what it does", and
// "a way to confirm ... and to back out of it in someway throughout both mobile
// and desktop". Until then a press on a slot cast at once.
// The choice is view state of this screen. The match record has the cast and
// the take back, not the choice.

import { createStore } from '../lib/store';
import { cancelCast, castSlot, gameStore } from './game';
import { actsFor } from './localSide';

/** The slot whose card is open, by its place among the slots of the side. Null when none is. */
export const castChoiceStore = createStore<number | null>(null);

export const chooseCast = (slot: number): void => castChoiceStore.set(slot);

export const dismissCast = (): void => castChoiceStore.set(null);

export const confirmCast = (): void => {
  const slot = castChoiceStore.get();
  castChoiceStore.set(null);
  if (slot !== null) castSlot(slot);
};

/** This screen cast a spell that waits for its picks, so it may take the cast back. */
export const canTakeBack = (): boolean => {
  const state = gameStore.get();
  return state.phase === 'aim' && state.pendingSlot !== null && actsFor(state.turn);
};

/** Call once at startup. Escape closes the card, or takes back a cast that waits for its picks. */
export const startCastKeys = (): void => {
  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (castChoiceStore.get() !== null) dismissCast();
    else if (canTakeBack()) cancelCast();
  });
  // A new state can make the open card stale: the turn passed, or a match began.
  gameStore.subscribe((state) => {
    if (castChoiceStore.get() !== null && (state.phase !== 'move' || !actsFor(state.turn)))
      dismissCast();
  });
};
